import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconAreasOfImprovementSvg } from './IconAreasOfImprovementSvg';

export type IconAreasOfImprovementProps = UseIconProps;

export function IconAreasOfImprovement(props: IconAreasOfImprovementProps) {
  const iconProps = useIcon({ size: 'x-large', ...props });

  return <Box tagName={IconAreasOfImprovementSvg} {...iconProps} />;
}
